/**
 * Tiny event emitter (P1-T11). No dependencies.
 * Used for auth-state changes, credit-balance refreshes, etc.
 */

export type Unsubscribe = () => void;

export class Emitter {
  private handlers = new Set<() => void>();

  on(handler: () => void): Unsubscribe {
    this.handlers.add(handler);
    return () => {
      this.handlers.delete(handler);
    };
  }

  emit(): void {
    for (const handler of [...this.handlers]) {
      try {
        handler();
      } catch (err) {
        console.error('[web] emitter handler threw:', err);
      }
    }
  }
}
